// extracted by mini-css-extract-plugin
export default {"container":"uY1V4g7QW0","icon":"aScNjgjhHz"};